interface Props {
  title: string;
  message: string;
}

export function ErrorScreen({ title, message }: Props): React.ReactElement {
  return (
    <div className="center-screen">
      <div className="card">
        <h1>{title}</h1>
        <p style={{ color: "var(--muted)" }}>{message}</p>
      </div>
    </div>
  );
}
